import { render } from "./CheckPoint.vue?vue&type=template&id=116a464e"
import script from "./CheckPoint.vue?vue&type=script&lang=js"
export * from "./CheckPoint.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__